import { AddNewAmenitiesModal } from "molecules/Modals/AddNewAmenitiesModal";
import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";

const NearByInfrastrucures = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/nearbyinfras/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, icon }) => {
          try {
            const reqData = { name, icon };
            const { data } = await api("/nearbyinfras/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, { name, icon }) => {
          try {
            const reqData = { name, icon };
            const { data } = await api(`/nearbyinfras/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/nearbyinfras/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Near By Infrastructure"
      addRecord="Add Infrastructure"
      searchRecord="Search Infrastructure"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{
        title: "Near By Infrastructure",
        CustomModal: AddNewAmenitiesModal,
      }}
    />
  );
};

export default NearByInfrastrucures;
